export const buildImageUrl = (blob: Blob) => {
  const url = window.URL || window.webkitURL;
  return url.createObjectURL(blob);
};
